import Vue from "vue";
import Vuex from "vuex";

import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

Vue.config.devtools = true;

import uxModule from "./Modules/uxModule";
import sharedModule from "./Modules/sharedModule";
import securityModule from "./Modules/securityModule";
import optionsModule from "./Modules/optionsModule";
import paymentBatchModule from "./Modules/paymentBatchModule";
import billingModule from "./Modules/billingModule";
import sessionModule from "./Modules/sessionModule";
import reportsModule from "./Modules/reportsModule";
const state = {};

const mutations = {};

const actions = {};

const store = new Vuex.Store({
  modules: {
    uxModule: uxModule,
    sharedModule: sharedModule,
    securityModule: securityModule,
    optionsModule: optionsModule,
    paymentBatchModule: paymentBatchModule,
    billingModule: billingModule,
    sessionModule: sessionModule,
    reportsModule: reportsModule,
  },

  state,
  mutations,
  actions,
  //plugins: [
  //  createPersistedState({
  //    storage: window.sessionStorage,
  //  }),
  //],
});

export default store;
